export function formatNumber(number, options = {}) {
  return parseFloat(number).toLocaleString('pt-BR', options);
}

export function replaceDotAndComma(number) {
  return parseFloat(number.replace('.', '').replace(',', '.'));
}
